export type BadgeSize = 'micro' | 'xsmall' | 'small' | 'medium' | 'large';

export interface BaseBadgeProps {
  size?: BadgeSize;
  width?: number;
  height?: number;
  backgroundColor?: string;
  iconColor?: string;
  className?: string;
  dataTestId?: string;
}

export const BADGE_SIZES = {
  micro: { size: 16, iconHeight: 8 },
  xsmall: { size: 24, iconHeight: 12 },
  small: { size: 32, iconHeight: 16 },
  medium: { size: 48, iconHeight: 24 },
  large: { size: 64, iconHeight: 32 },
} as const;
